export default "__VITE_ASSET__$CR27Cha__"